/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { IncidentInvestigationControllerReportMarkdownQueryResponse, IncidentInvestigationControllerReportMarkdownPathParams, IncidentInvestigationControllerReportMarkdown400, IncidentInvestigationControllerReportMarkdown401, IncidentInvestigationControllerReportMarkdown403, IncidentInvestigationControllerReportMarkdown404, IncidentInvestigationControllerReportMarkdown409 } from "../../models/incidentAgentController/IncidentInvestigationControllerReportMarkdown";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { incidentInvestigationControllerReportMarkdown } from "../../clients/incident-agentService/incidentInvestigationControllerReportMarkdown";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const incidentInvestigationControllerReportMarkdownQueryKey = (id: IncidentInvestigationControllerReportMarkdownPathParams["id"]) => [{
  url: '/api/v1/incident-agent/investigations/:id/report/markdown',
  params: {
    id: id
  }
}] as const;
export type IncidentInvestigationControllerReportMarkdownQueryKey = ReturnType<typeof incidentInvestigationControllerReportMarkdownQueryKey>;
export function incidentInvestigationControllerReportMarkdownQueryOptions(id: IncidentInvestigationControllerReportMarkdownPathParams["id"], config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = incidentInvestigationControllerReportMarkdownQueryKey(id);
  return queryOptions<IncidentInvestigationControllerReportMarkdownQueryResponse, ResponseErrorConfig<IncidentInvestigationControllerReportMarkdown400 | IncidentInvestigationControllerReportMarkdown401 | IncidentInvestigationControllerReportMarkdown403 | IncidentInvestigationControllerReportMarkdown404 | IncidentInvestigationControllerReportMarkdown409>, IncidentInvestigationControllerReportMarkdownQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return incidentInvestigationControllerReportMarkdown(id, config);
    }
  });
}

/**
 * {@link /api/v1/incident-agent/investigations/:id/report/markdown}
 */
export function useIncidentInvestigationControllerReportMarkdown<TData = IncidentInvestigationControllerReportMarkdownQueryResponse, TQueryData = IncidentInvestigationControllerReportMarkdownQueryResponse, TQueryKey extends QueryKey = IncidentInvestigationControllerReportMarkdownQueryKey>(id: IncidentInvestigationControllerReportMarkdownPathParams["id"], options: {
  query?: Partial<QueryObserverOptions<IncidentInvestigationControllerReportMarkdownQueryResponse, ResponseErrorConfig<IncidentInvestigationControllerReportMarkdown400 | IncidentInvestigationControllerReportMarkdown401 | IncidentInvestigationControllerReportMarkdown403 | IncidentInvestigationControllerReportMarkdown404 | IncidentInvestigationControllerReportMarkdown409>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? incidentInvestigationControllerReportMarkdownQueryKey(id);
  const query = useQuery({
    ...incidentInvestigationControllerReportMarkdownQueryOptions(id, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<IncidentInvestigationControllerReportMarkdown400 | IncidentInvestigationControllerReportMarkdown401 | IncidentInvestigationControllerReportMarkdown403 | IncidentInvestigationControllerReportMarkdown404 | IncidentInvestigationControllerReportMarkdown409>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}